import { Outlet, Navigate, useLocation } from 'react-router-dom';
import DashboardNavbar from './DashboardNavbar';
import LowCreditBanner from './LowCreditBanner';
import PaywallModal from '../modals/PaywallModal';
import { CreditProvider } from '../../context/CreditContext';
import { useAuth } from '../../context/AuthContext';

export default function DashboardLayout() {
    const { isAuthenticated } = useAuth();
    const location = useLocation();

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    if (location.pathname === '/dashboard') {
        return <Navigate to="/dashboard/overview" replace />;
    }

    return (
        <CreditProvider>
            <div className="min-h-screen bg-[#0B0B0F] text-white selection:bg-brand-500/30 font-sans">
                <DashboardNavbar />
                <LowCreditBanner />
                <main className="pt-24 pb-12 max-w-7xl mx-auto px-6 animate-fade-in relative z-10">
                    <Outlet />
                </main>
                <PaywallModal />
            </div>
        </CreditProvider>
    );
}
